import { getRangePickerValue } from '@intelligence/v3/filterControls/rangePicker/utils';
import { hasRobloxFilterDate } from '@intelligence/v3/utils/robloxFilterDate';
import { getDefulatTimeValue } from '@intelligence/utils/common';

import type { IFilterValues } from '@intelligence/v3/filterCore/types';
import type { IRangePickerFilterValue } from '@intelligence/v3/filterControls/rangePicker/types';

export interface IRobloxTopChartsDefaultDateItem {
  date_type?: string;
  start_date?: string;
  end_date?: string;
}

export const formatRobloxTopChartsDefaultDateList = (
  dateList: IRobloxTopChartsDefaultDateItem[],
): Record<string, [string, string]> => {
  const result: Record<string, [string, string]> = {};

  dateList.forEach((item) => {
    const startDate = item?.start_date || '';
    const endDate = item?.end_date || '';

    if (!startDate || !endDate) {
      return;
    }

    if (item.date_type === 'monthly') {
      result.monthly = [startDate, endDate];
      return;
    }

    if (item.date_type === 'weekly') {
      result.weekly = [startDate, endDate];
      return;
    }

    if (item.date_type === 'daily') {
      result.daily = [startDate, endDate];
    }
  });

  return result;
};

/** 对齐 ActiveUsers：接口失败或空数据时回退到 getDefulatTimeValue 内置默认日期 */
export const buildRobloxTopChartsComponentDefault = (
  rawDateList?: IRobloxTopChartsDefaultDateItem[] | null,
): Record<string, [string, string]> => {
  const dateList = getDefulatTimeValue(rawDateList || []);

  return formatRobloxTopChartsDefaultDateList(dateList);
};

export const getRobloxTopChartsFilterDateFromComponentDefault = (
  filterValues: IFilterValues,
  componentDefault: Record<string, [string, string]>,
): IRangePickerFilterValue | null => {
  if (hasRobloxFilterDate(filterValues)) {
    return null;
  }

  const { granularity } = getRangePickerValue(filterValues?.date);
  const currentGranularity = granularity || 'daily';
  const range = componentDefault[currentGranularity] || componentDefault.daily;

  if (!range?.[0] || !range?.[1]) {
    return null;
  }

  return {
    granularity: currentGranularity,
    startDate: range[0],
    endDate: range[1],
  };
};
